import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import {
    AvailabilityDto,
    AvailabilityMessageType,
    ProductSettingsModel,
    WarehouseDto,
} from "@insite/client-framework/Types/ApiModels";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconWrapper } from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Check from "@insite/mobius/Icons/Check";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ReelModal from "@tKgpco/Components/ReelModal";
import getRealTimeWarehouseInventory from "@tKgpco/Handlers/AddCustomRealTimeWarehouseInventory";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

interface OwnProps {
    productId: string;
    availability?: AvailabilityDto;
    unitOfMeasure: string;
    trackInventory: boolean;
    isProductDetailsPage?: boolean;
    failedToLoadInventory?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
    inventory?: number;
    // reelFinalInventory: any[];
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    showInventory: state.context.showInventory,
});

const mapDispatchToProps = {
    getRealTimeWarehouseInventory,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductAvailabilityStyles {
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    messageOutofStockGridItem?: GridItemProps;
    availabilityByWarehouseLinkGridItem?: GridItemProps;
    inventoryMessage?: InjectableCss;
    messageText?: TypographyPresentationProps;
    realTimeText?: TypographyPresentationProps;
    errorWrapper?: InjectableCss;
    errorText?: TypographyPresentationProps;
    availabilityByWarehouseLink?: LinkPresentationProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    availabilityByWarehouseTable?: DataTableProps;
    availabilityByWarehouseTableHead?: DataTableHeadProps;
    availabilityByWarehouseTableHeader?: DataTableHeaderProps;
    availabilityByWarehouseTableBody?: DataTableBodyProps;
    availabilityByWarehouseTableRow?: DataTableRowProps;
    availabilityByWarehouseTotalTableRow?: DataTableRowProps;
    availabilityByWarehouseTableCell?: DataTableCellBaseProps;
    availabilityByWarehouseTableCellLeft?: DataTableCellBaseProps;
    reelavailabilityByWarehouseLink?: LinkPresentationProps;
    accordionSection?: AccordionSectionPresentationProps;
}

export const productAvailabilityStyles: ProductAvailabilityStyles = {
    availabilityByWarehouseTableCellLeft: {
        css: css`
            margin-right: auto;
            display: flex;
            align-items: center;
            span {
                font-weight: 500;
            }
        `,
    },
    availabilityByWarehouseTableCell: {
        css: css`
            display: flex;
            align-items: center;
            padding-right: 4px !important;
        `,
    },
    accordionSection: {
        headerProps: {
            css: css`
                button {
                    padding: 0px;
                    &:focus {
                        padding: 0px;
                    }
                }
            `,
        },
        css: css`
            width: 100%;
        `,
    },
    container: {
        gap: 0,
        css: css`
            flex-grow: 0;
        `,
    },
    messageGridItem: { width: 7 },
    messageOutofStockGridItem: { width: 6 },
    availabilityByWarehouseLinkGridItem: {
        width: 5,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        justify-content: flex-end;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
            > button {
                background: #e1e7ed;
                padding: 3px 4px;
                border-radius: 4px;
                > span {
                    color: #353432 !important;
                    font-size: ${TYPOGRAPHY.size.vTiny};
                    @media (max-width: 1199px) and (min-width: 992px) {
                        font-size: 10px !important;
                    }
                }
            }
        `,
    },
    reelavailabilityByWarehouseLink: {
        css: css`
            text-decoration: underline;
            text-decoration-color: #0b70b7;
            span {
                color: #0b70b7 !important;
            }
        `,
    },
    availabilityByWarehouseModal: {
        size: 734,
        cssOverrides: {
            modalContent: css`
                padding: 0;
                margin: 10px 20px 20px 20px;
                font-size: ${TYPOGRAPHY.size.smaller};
                table[data-test-selector="availabilityByWarehouseModal"] {
                    margin-top: 20px;
                    thead {
                        background: transparent linear-gradient(180deg, #44a8f7 0%, #1e75ba 100%) 0% 0% no-repeat;
                        tr {
                            th {
                                background: transparent;
                                border: 0 none;
                                padding: 0 20px;
                                span {
                                    color: #ffffff;
                                    font-size: ${TYPOGRAPHY.size.base};
                                }
                                &:first-child {
                                    border-top-left-radius: 4px;
                                }
                                &:last-child {
                                    border-top-right-radius: 4px;
                                    text-align: right;
                                }
                            }
                        }
                    }
                    tbody {
                        font-weight: 500;
                        tr {
                            border: 1px solid #e1e7ed;
                            // border-bottom: 0;
                            td {
                                height: 40px;
                                border-bottom: none;
                                padding: 15px 20px;
                                button {
                                    span {
                                        color: #000;
                                    }
                                    &:last-child {
                                        border-bottom: none;
                                    }
                                }
                                :last-child {
                                    text-align: right;
                                }
                            }
                            td,
                            span {
                                font-size: ${TYPOGRAPHY.size.smaller};
                            }
                            &:nth-child(even) {
                                background: #fff;
                            }
                        }
                    }
                }
            `,
            modalTitle: css`
                padding: 20px 10px 0 20px;
                border-bottom: none;
                h4 {
                    font-size: 22px;
                    font-weight: ${TYPOGRAPHY.weight.bold};
                }
                svg {
                    height: 22px;
                    width: 22px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                h4 {
                                    font-size: 20px;
                                }
                                svg {
                                    height: 20px;
                                    width: 20px;
                                }
                            `,
                        ],
                        "max",
                    )}
            `,
            headlineTypography: css`
                font-size: 22px;
                margin-bottom: 0;
            `,
        },
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    messageText: {
        css: css`
            width: 100%;
            ${wrapInContainerStyles}
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
    realTimeText: {
        weight: "bold",
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    errorText: {
        weight: "bold",
    },
    availabilityByWarehouseTotalTableRow: {
        css: css`
            border: 0 !important;
            font-weight: ${TYPOGRAPHY.weight.bold};
            td {
                height: 52px !important;
                background: #e3edf7;
                &:first-child {
                    border-bottom-left-radius: 4px;
                }
                &:last-child {
                    border-bottom-right-radius: 4px;
                }
            }
        `,
    },
};

const InventoryMessage = styled.div<{ color: string }>`
    display: flex;
    align-items: center;
    border-radius: 5px;
    color: ${props => props.color};
    ${IconWrapper} {
        margin-right: 10px;
    }
`;

const getAvailabilityColor = (productSettings: ProductSettingsModel, availability?: AvailabilityDto) => {
    if (!productSettings.showInventoryAvailability) {
        // return "common";
        return "#cccccc";
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        // return "danger";
        return "#FD7705";
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return "#E8AA0F";
        // return "warning";
    }

    return "#3CB56F";
    // return "success";
};

const getAvailabilityIcon = (productSettings: ProductSettingsModel, availability?: AvailabilityDto) => {
    if (!productSettings.showInventoryAvailability) {
        return undefined;
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return X;
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return AlertTriangle;
    }

    return Check;
};

const showLink = (
    availability: AvailabilityDto | undefined,
    trackInventory: boolean,
    productSettings: ProductSettingsModel,
    isProductDetailsPage?: boolean,
): boolean => {
    if (
        !availability ||
        availability.messageType === AvailabilityMessageType.NoMessage ||
        availability.message === siteMessage("Inventory_DropShip") ||
        !trackInventory ||
        !productSettings.showInventoryAvailability ||
        !productSettings.displayInventoryPerWarehouse
    ) {
        return false;
    }

    if (!productSettings.displayInventoryPerWarehouseOnlyOnProductDetail) {
        return true;
    }

    return !!isProductDetailsPage;
};

const ProductAvailability = ({
    productId,
    availability,
    unitOfMeasure,
    trackInventory,
    productSettings,
    isProductDetailsPage,
    getRealTimeWarehouseInventory,
    failedToLoadInventory,
    extendedStyles,
    inventory,
    showInventory,
}: Props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    // const [reelModalIsOpen, reelSetModalIsOpen] = useState(false);
    const [selectedWareHouseId, setSelectedWareHouseId] = useState<string>("");
    const [warehouses, setWarehouses] = useState<WarehouseDto[] | undefined>(undefined);
    const [reelInventoryArr, setReelInventoryArr] = useState<{ [key: string]: string }>({});
    const [reelFinalInventory, setReelFinalInventory] = useState<Record<string, any[]>>({});
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    // const reelmodalCloseHandler = () => {
    //     reelSetModalIsOpen(false);
    // };
    const viewAvailabilityByWarehouseClickHandler = () => {
        setIsLoading(true);
        setModalIsOpen(true);
        getRealTimeWarehouseInventory({
            productId,
            unitOfMeasure,
            expand: ["warehouses"],
            onComplete: result => {
                setReelInventoryArr(result.additionalResults!);
                setWarehouses(result.warehouses);
                setErrorMessage(result.errorMessage);
                setIsLoading(false);
            },
        });
    };
    const viewReelAvailabilityByWarehouseClickHandler = (expanded: boolean, wareHouseId: string) => {
        const reelInventoryById: any = reelInventoryArr[wareHouseId];
        if (!reelInventoryById || selectedWareHouseId === wareHouseId) {
            setSelectedWareHouseId("");
            return false;
        }
        if (reelFinalInventory[wareHouseId]) {
            setSelectedWareHouseId(wareHouseId);
            return true;
        }
        const reelsArrayFromString: string[] = JSON.parse(reelInventoryById);
        const reelArry: any[] = reelsArrayFromString.map(reelInv => {
            const reelInvData = reelInv.split(":");
            return {
                reelId: reelInvData[0],
                reelQty: reelInvData[1],
                siteId: reelInvData[2],
                warehouseId: wareHouseId,
            };
        });

        setReelFinalInventory({ ...reelFinalInventory, [wareHouseId]: reelArry });
        setSelectedWareHouseId(wareHouseId);
        // reelSetModalIsOpen(true);
    };

    const color = getAvailabilityColor(productSettings, availability);
    const iconSrc = getAvailabilityIcon(productSettings, availability);

    const [styles] = useState(() => mergeToNew(productAvailabilityStyles, extendedStyles));

    if (!showInventory) {
        return null;
    }

    if (failedToLoadInventory) {
        return (
            <StyledWrapper {...styles.errorWrapper}>
                <Typography {...styles.errorText} data-test-selector="inventoryLoadFailedMessage">
                    {siteMessage("RealTimeInventory_InventoryLoadFailed")}
                </Typography>
            </StyledWrapper>
        );
    }

    let inventoryTextComponent = <Typography {...styles.realTimeText} />;
    if (availability?.messageType !== AvailabilityMessageType.NoMessage && availability?.message?.length) {
        inventoryTextComponent = (
            <InventoryMessage color={color} {...styles.inventoryMessage}>
                {/* <Icon color={color} src={iconSrc} /> */}
                <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                    {availability.message}
                </Typography>
            </InventoryMessage>
        );
    } else if (availability) {
        inventoryTextComponent = <></>;
    }

    return (
        <GridContainer {...styles.container}>
            <GridItem
                {...(showLink(availability, trackInventory, productSettings, isProductDetailsPage)
                    ? { ...styles.messageGridItem }
                    : { ...styles.messageOutofStockGridItem })}
            >
                {inventoryTextComponent}
            </GridItem>
            {showLink(availability, trackInventory, productSettings, isProductDetailsPage) && (
                <GridItem {...styles.availabilityByWarehouseLinkGridItem}>
                    <Link
                        {...styles.availabilityByWarehouseLink}
                        onClick={viewAvailabilityByWarehouseClickHandler}
                        data-test-selector="availabilityByWarehouseLink"
                    >
                        {translate("See Availability")}
                    </Link>
                    <Modal
                        {...styles.availabilityByWarehouseModal}
                        headline={translate("Inventory by Distribution Center")}
                        isOpen={modalIsOpen}
                        handleClose={modalCloseHandler}
                        sizeVariant="large"
                    >
                        <Typography>{siteMessage("SeeAvailability_Model")}</Typography>
                        {isLoading && (
                            <StyledWrapper {...styles.centeringWrapper}>
                                <LoadingSpinner {...styles.spinner} />
                            </StyledWrapper>
                        )}
                        {!isLoading && (
                            <>
                                {errorMessage ? (
                                    <div>{errorMessage}</div>
                                ) : (
                                    <DataTable
                                        {...styles.availabilityByWarehouseTable}
                                        data-test-selector="availabilityByWarehouseModal"
                                    >
                                        <DataTableHead {...styles.availabilityByWarehouseTableHead}>
                                            <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                                {translate("Distribution Center")}
                                            </DataTableHeader>
                                            <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                                {translate("QTY")}
                                            </DataTableHeader>
                                        </DataTableHead>
                                        <DataTableBody {...styles.availabilityByWarehouseTableBody}>
                                            {warehouses?.map(warehouse => (
                                                <DataTableRow
                                                    {...styles.availabilityByWarehouseTableRow}
                                                    key={warehouse.name}
                                                >
                                                    {!reelInventoryArr[warehouse.name] ? (
                                                        <>
                                                            <DataTableCell
                                                                // {...styles.availabilityByWarehouseTableCellLeft}
                                                                data-test-selector="warehouseAvailabilityModal_Description"
                                                            >
                                                                {warehouse.description || warehouse.name}
                                                            </DataTableCell>
                                                            <DataTableCell
                                                                // {...styles.availabilityByWarehouseTableCell}
                                                                data-test-selector="warehouseAvailabilityModal_Quantity"
                                                            >
                                                                {warehouse.qty}
                                                            </DataTableCell>
                                                        </>
                                                    ) : (
                                                        <DataTableCell
                                                            colSpan={2}
                                                            css={css`
                                                                padding: 0px !important;
                                                            `}
                                                        >
                                                            <AccordionSection
                                                                title={
                                                                    <>
                                                                        <DataTableCell
                                                                            {...styles.availabilityByWarehouseTableCellLeft}
                                                                            data-test-selector="warehouseAvailabilityModal_Description"
                                                                        >
                                                                            {warehouse.description || warehouse.name}
                                                                        </DataTableCell>
                                                                        <DataTableCell
                                                                            {...styles.availabilityByWarehouseTableCell}
                                                                            data-test-selector="warehouseAvailabilityModal_Quantity"
                                                                        >
                                                                            {reelInventoryArr === null ||
                                                                            warehouse.qty === 0 ? (
                                                                                warehouse.qty
                                                                            ) : (
                                                                                <Link
                                                                                    {...styles.reelavailabilityByWarehouseLink}
                                                                                    data-test-selector="availabilityByWarehouseLink"
                                                                                    data-warehouse-id={warehouse.name}
                                                                                >
                                                                                    {warehouse.qty}
                                                                                </Link>
                                                                            )}
                                                                        </DataTableCell>
                                                                    </>
                                                                }
                                                                expanded={selectedWareHouseId === warehouse.name}
                                                                onTogglePanel={expanded =>
                                                                    viewReelAvailabilityByWarehouseClickHandler(
                                                                        expanded,
                                                                        warehouse.name,
                                                                    )
                                                                }
                                                                {...styles.accordionSection}
                                                            >
                                                                {reelFinalInventory[warehouse.name] && (
                                                                    <>
                                                                        <Typography
                                                                            as="p"
                                                                            color="primary"
                                                                            size={14}
                                                                            style={{
                                                                                textAlign: "center",
                                                                            }}
                                                                        >
                                                                            {siteMessage("reel_disclaimer_msg_contact")}
                                                                        </Typography>
                                                                        <ReelModal
                                                                            productId={productId}
                                                                            errorMessage={errorMessage}
                                                                            isLoading={isLoading}
                                                                            reelFinalInventory={
                                                                                reelFinalInventory[warehouse.name]
                                                                            }
                                                                            unitOfMeasure={unitOfMeasure}
                                                                        />
                                                                    </>
                                                                )}
                                                            </AccordionSection>
                                                        </DataTableCell>
                                                    )}
                                                </DataTableRow>
                                            ))}
                                            <DataTableRow {...styles.availabilityByWarehouseTotalTableRow}>
                                                <DataTableCell>Total Availability</DataTableCell>
                                                <DataTableCell>{inventory}</DataTableCell>
                                            </DataTableRow>
                                        </DataTableBody>
                                    </DataTable>
                                )}
                            </>
                        )}
                    </Modal>
                </GridItem>
            )}
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAvailability);
